module.exports = __webpack_public_path__ + "img/icon_submenu19.4a48239c.svg";